module.exports = __webpack_public_path__ + "img/pc_right.9cce4f5.webp";